<template>



        <!-- <v-divider
          v-else-if="item.divider"
          :key="index"
          :inset="item.inset"
        ></v-divider> -->
<!-- 
        <v-list-item
          v-else
          :key="item.title"
          @click=""
        > -->
         <v-list-item
        
          class="Searchresult"
        >
          <v-list-item-avatar>
            <!-- <v-img :src="img"></v-img> -->
          <v-icon>mdi-map-marker</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-html="title"></v-list-item-title>
            <v-list-item-subtitle v-html="subtitle"></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>


</template>

<script>
export default {
    props: {
 title : String,
 subtitle: String,
 image: String
    },

  name: 'Searchresult'
}
</script>

<style scoped>
.Searchresult {
  margin: auto;
}
</style>

